// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__5+6CH","logo":"style__logo__1momk"};